import { OnboardingStatusGetParameters, useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useGetOnboardingStatus = (params: OnboardingStatusGetParameters) =>
    useRepositorySuspenseQuery('enterprises', 'getOnboardingStatus', params);
